import {Link, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useWindowSize} from "../../../../hook/useWindowSize";
import {useMySearchParams} from "../../../../hook/useMySearchParams";
import SearchBox from "../../../components/general/searchBox";
import Pagination from "../../../components/general/table/pagination";
import ProgramsTable from "../../../components/basicInformation/program/dataList/programsTable";
import ProgramCardsBox from "../../../components/basicInformation/program/dataList/programCardsBox";
import {useGetPrograms} from "../../../../hook/request/program";
import {ROUTES} from "../../../../constants";
import Icon from "../../../components/general/icon";
import DeleteProgramModal from "../../../components/basicInformation/program/deleteProgramModal";
import {useFindAccessInAccessList} from "../../../../constants/constant/accessProcess";

const dataListTitles = [
  "نام واکسن",
  "توضیحات",
]

type TFilterValues = {
  pageNumber?: string;
  perPage?: string;
  search?: string;
}

const ProgramsList = () => {

  const [width] = useWindowSize();
  const {findAccessInAccessList} = useFindAccessInAccessList();
  const [searchParams] = useSearchParams();
  const { getQueryParams, updateSearchParams } = useMySearchParams();
  const [programsData, setProgramsData] = useState([]);
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    pageNumber: "0",
    perPage: "10",
    search: "",
  });

  // services
  const getProgramsRequest = useGetPrograms(getQueryParams(filterValues));

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "10",
      search: searchParams.get("search") || "",
    }
    setFilterValues(_filterValues)
  }, [searchParams]);

  useEffect(() => {
    getProgramsRequest?.data?.data?.result &&
    setProgramsData(getProgramsRequest?.data?.data.result)
  }, [getProgramsRequest.data])

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    updateSearchParams({
      pageNumber: "0",
      perPage: filterValues?.perPage,
      [name]: value,
    })
  }

  const doChangePage = (param: any) => {
    updateSearchParams({
      pageNumber: param?.index,
      perPage: filterValues?.perPage,
    })
  }

  return (
    <>
      <div className="card-box">
        <section className="filter-box d-flex flex-column flex-md-row mb-4">
          <div className="form-group ms-md-auto">
            <SearchBox
              name="search"
              value={filterValues?.search}
              onChange={handleFilterChange}
              placeholder="جستجوی برنامه آموزش درمانی"
            />
          </div>
          {
            findAccessInAccessList('BASIC_MEDICAL_PROGRAMS') &&
            <div className="d-flex align-items-center align-items-stretch justify-content-center justify-content-md-start mb-3 m-md-0">
              <Link to={ROUTES.PROGRAM_ADD.PATH} className="btn btn-primary rounded d-flex align-items-center fw-bold px-4">
                <span className="d-inline-flex font-25 ms-2 ps-2"><Icon name="add-square"/></span>
                افزودن برنامه
              </Link>
            </div>
          }
        </section>

        <section className="table-cont table-responsive">
          {
            width < 900 ?
              <ProgramCardsBox
                dataList={programsData}
                dataListTitles={dataListTitles}
                isRequesting={getProgramsRequest.isPending}
              /> :
              <ProgramsTable
                dataList={programsData}
                dataListTitles={dataListTitles}
                isRequesting={getProgramsRequest.isPending}
              />
          }
          <Pagination
            paginationData={{...filterValues, ...programsData}}
            doChangePage={doChangePage}
          />
        </section>
      </div>
      <DeleteProgramModal/>
    </>
  );
};

export default ProgramsList;